import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-editar-cotizacion',
  templateUrl: './editar-cotizacion.component.html',
  styleUrls: ['./editar-cotizacion.component.scss']
})
export class EditarCotizacionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
